import { AcoFormData, AvatarIcon, IdentityInfo } from '@tt4b/ttam-enums';

/* eslint-disable camelcase */
export interface ImageInfo {
  hash: string;
  name: string;
  src_h: number;
  format: string;
  web_uri_v2: string;
  height: number;
  width: number;
  mode: number;
  src_uri: string;
  src_w: number;
  size: number;
  web_uri: string;
  d: number;
}

export interface AvatarData {
  image_info: ImageInfo;
  url: string;
  uri: string;
}

export type CreateIdentityFormData = {
  avatarIcon: AvatarIcon | Record<string, unknown>;
  displayName: string;
};

export type IdentityBannerItem = {
  bannerType: 'TTBC' | 'TTBA';
  isEmpty: boolean;
};

export type IdentityItem = {
  display_name: string;
  displayName: string;
  avatar: string;
  id: string;
  identity_id: string;
  desc?: string;
  descIcon?: string;
  disabled?: boolean;
  enablePopover?: boolean;
  popoverTitle?: string;
  username?: string;
  popoverCTA?: string;
  popoverTea?: Record<string, unknown>;
  popoverCtaTea?: string;
};

export type PostAuthorizeForm = {
  videoCode: string;
  fromVideoCode: string;
};

export type PreviewVideoInfo = {
  nickName: string;
  text: string;
  coreUserId: string;
  duration: string;
  resolution: string;
  fileSize: string;
  bitrate: string;
  avatar: string;
  url: string;
  poster: string;
  anchor: string;
};

export type TypeSelectItem = {
  title: string;
  desc: string;
  subtitle?: string;
  icon: string;
  value: number[];
};

export type TikTokAccountType = {
  name: string;
  avatar: string;
  id: string;
  unavailable: boolean;
  availableStatus?: number;
};

export type IdentityFullInfo = IdentityBannerItem & IdentityItem & IdentityInfo;

export enum NativeIdentityType {
  TIKTOK = 'tiktok',
  POST = 'post',
}
